import { useEffect, useState } from "react";
import { DollarSign, User } from "react-feather";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateTransporterCharge } from "../../api/finance/transporter-invoice";
import Grid from "../../components/Grid";
import InfoList from "../../components/InfoList";
import LoadingSpinner from "../../components/LoadingSpinner";
import Button from "../../components/input/Button";
import { MODULES } from "../../const";
import {
    formatFromJsonDateUtc
} from "../../dateConfig";

const AddTransporterCharges = ({
    jobInfo,
    editMode,
    handleDrawerClose,
    detailChanges,
    headerChanges
}) => {
    const userData = useSelector((state) => state.user.userDetails);
    const user = useSelector((state) => state.user);

    const [drawerTab, setDrawerTab] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isBlurred, setIsBlurred] = useState(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [jobData, setJobData] = useState({});
    const [JobSummary, setJobSummary] = useState([]);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [deletedList, setDeletedList] = useState([]);
    const [kmValue, setKmValue] = useState("");

    useEffect(() => {
        (async () => {
            console.log("detailChanges", detailChanges)
            if (editMode) {
                const h = headerChanges;

                const headerArray = [
                    { title: "Job Code", value: h.tthReference || "N/A" },
                    { title: "Transporter", value: h.tthTransporterName || "N/A" },
                    {
                        title: "KM Value",
                        value: kmValue !== "" ? kmValue : (h.tthKmValue ?? ""),
                        type: "number",
                        onChange: (val) => setKmValue(val),
                    },
                ];

                setJobSummary(headerArray);
                if (kmValue === "") {
                    setKmValue(h.tthKmValue ?? "");
                }
                const mappedData = detailChanges.map(row => ({
                    ...row,
                    ttdQty: row.ttdQty ?? 1,
                }));
                setGridData(mappedData || []);
            }
        })();
    }, [editMode, detailChanges, kmValue]);


    const getConfig = () => [
        {
            headerName: "Charge",
            field: "ttdChargeName",
            editable: false,
        },
        {
            headerName: "Value",
            field: "ttdValue",
            editable: true,
            cellEditor: "agNumberCellEditor", // <-- number only editor
            valueParser: (params) => {
                const n = Number(params.newValue);
                // return isNaN(n) ? 0 : n; // fallback to 0 if invalid
                if (isNaN(n)) return 0;
                return Math.abs(n);
            },
            valueFormatter: (params) => {
                const n = Number(params.value);
                return isNaN(n) ? "" : n.toFixed(2);
            },
        },
        {
            headerName: "Qty",
            field: "ttdQty",
            editable: true,
            cellEditor: "agNumberCellEditor", // <-- number only editor
            valueParser: (params) => {
                const n = Number(params.newValue);
                return isNaN(n) ? 0 : n; // fallback to 0 if invalid
            },
            valueFormatter: (params) => {
                const n = Number(params.value);
                return isNaN(n) ? "" : String(n);
            },
            hide: true,
        },

        {
            headerName: "Total",
            field: "ttdTotal",
            editable: false,
            valueGetter: (params) => {
                const value = Number(params.data?.ttdValue || 0);
                const qty = Number(params.data?.ttdQty || 0);
                return value * qty;
            },
            valueFormatter: (params) => {
                const n = Number(params.value);
                return isNaN(n) ? "0.00" : n.toFixed(2);
            },
        }

    ];

    const updateCharge = async (e) => {
        e.preventDefault();
        setIsUpdateLoading(true);
        setIsBlurred(true);
        const updateState = getUpdateState();

        console.log("updateState", updateState)
        if (

            updateState.modified.length !== 0
        ) {
            if (gridData?.length === 0) {
                toast.error("Please add charges", {
                    autoClose: 5000,
                    containerId: "Main",
                });
                setIsUpdateLoading(false);
                setIsBlurred(false);
                return;
            }
        }
        const response = await updateTransporterCharge({
            transporterChargeDetail: updateState,
            kmValue: kmValue === "" ? null : kmValue,
            author: user.username
        })
        if (!response.success) {
            toast.error(response.message, {
                autoClose: 5000,
                containerId: "Main",
            });
            // reset();
        } else {
            toast.success(response.message, {
                autoClose: 5000,
                containerId: "Main",
            });
            // reset();
        }

        setIsUpdateLoading(false);
        setIsBlurred(false);
        setIsSubmitLoading(false);
        handleDrawerClose();

    }
    const addCharge = async (e) => {
        e.preventDefault();
    }

    const getUpdateState = () => {
        const updateState = {
            created: [],
            modified: [],
            deleted: deletedList,
        };

        gridData.forEach((shu) => {
            console.log("shu00000000000", shu)
            updateState.modified.push(shu);
        });

        return updateState;
    };

    return (
        <>
            {isBlurred && (
                <div className="blur-overlay">
                    <LoadingSpinner message={editMode ? "Updating..." : "Saving..."} />
                </div>
            )}
            <div className="drawer-content">
                <div className="ui top attached tabular menu">
                    <div
                        className={`item ${drawerTab === 1 ? "active" : ""}`}
                        onClick={() => {
                            setDrawerTab(1);
                        }}
                    >
                        <span>
                            <DollarSign
                                size={15}
                                style={{
                                    marginRight: "5px",
                                }}
                            />
                        </span>
                        <label>Transporter Charges</label>
                    </div>
                </div>
                <div
                    className="ui bottom attached active tab segment"
                    style={{ display: drawerTab === 1 ? "block" : "none" }}
                >
                    {isLoading
                        ? (
                            <LoadingSpinner />
                        ) : (
                            <>
                                <InfoList content={JobSummary} title={"Job Details"} textField={true} />

                                <div className="ui segment">
                                    <div
                                        style={{ display: "flex", justifyContent: "space-between" }}
                                    >
                                    </div>

                                    <Grid
                                        // ref={gridRef}
                                        searchable={false}
                                        module={MODULES.Finance}
                                        // multiRowSelection={containsAnyGridPermissions()}
                                        // showDownloadButton={chargeDetailPermissions?.FORM?.DOWNLOAD}
                                        // downloadParam={""}
                                        // downloadAction="Charge Creation Excel Download"
                                        // downloadOnlySelected={true}
                                        heading="Add Charges"
                                        stopEditingWhenCellsLoseFocus={true}
                                        // onSelectionChanged={handleSelectionChanged}
                                        // onCellEditingStopped={cellEditorParams}
                                        // onCellDoubleClicked={cellDoubleClickHandler}
                                        content={gridData}
                                        fullRowEdit={false}
                                        config={getConfig()}
                                        gridOptions={{
                                            getRowStyle: (params) => {
                                                const value = Number(params.data?.ttdValue || 0);
                                                const qty = Number(params.data?.ttdQty || 0);

                                                if (value > 0) {
                                                    return { backgroundColor: "#ffe5e5" };
                                                }
                                                return null;
                                            },
                                        }}

                                    />
                                    <>
                                        {editMode && (
                                            <InfoList
                                                title="User Information"
                                                content={[
                                                    {
                                                        title: "Created By",
                                                        value: headerChanges.tthCreatedBy
                                                            ? headerChanges.tthCreatedBy
                                                            : "N/A",
                                                    },
                                                    {
                                                        title: "Created Date",
                                                        value: headerChanges.tthCreatedDate
                                                            ? formatFromJsonDateUtc(headerChanges.tthCreatedDate)
                                                            : "N/A",
                                                    },
                                                    {
                                                        title: "Last Modified By",
                                                        value: headerChanges.tthModifiedBy
                                                            ? headerChanges.tthModifiedBy
                                                            : "N/A",
                                                    },
                                                    {
                                                        title: "Last Modified Date",
                                                        value: headerChanges.tthModifiedDate
                                                            ? formatFromJsonDateUtc(headerChanges.tthModifiedDate)
                                                            : "N/A",
                                                    },
                                                ]}
                                                Icon={User}
                                            />
                                        )}
                                    </>
                                    <div className="ui divider"></div>

                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        {/*    {!editMode ? (*/}
                                        {/*        <Button*/}
                                        {/*            type="submit"*/}
                                        {/*            template="create"*/}
                                        {/*            isLoading={isSubmitLoading}*/}
                                        {/*            module={MODULES.Finance}*/}
                                        {/*            form={HEADER_FORM}*/}
                                        {/*            authenticated={true}*/}
                                        {/*            editMode={editMode}*/}
                                        {/*            onClick={(e) => {*/}
                                        {/*                addCharge(e);*/}
                                        {/*            }}*/}
                                        {/*            disabled={*/}
                                        {/*                !(gridData.length > 0 && selectedRows.length > 0)*/}
                                        {/*            }*/}
                                        {/*        />*/}
                                        {/*    ) : (*/}
                                        {/*        <Button*/}
                                        {/*            type="submit"*/}
                                        {/*            template="create"*/}
                                        {/*            create={false}*/}
                                        {/*            isLoading={isUpdateLoading}*/}
                                        {/*            module={MODULES.Finance}*/}
                                        {/*            form={HEADER_FORM}*/}
                                        {/*            authenticated={true}*/}
                                        {/*            editMode={editMode}*/}
                                        {/*            onClick={(e) => {*/}
                                        {/*                updateCharge(e);*/}
                                        {/*            }}*/}
                                        {/*            disabled={*/}
                                        {/*                !(*/}
                                        {/*                    (gridData.length > 0 && selectedRows.length > 0) ||*/}
                                        {/*                    deletedList.length > 0*/}
                                        {/*                )*/}
                                        {/*            }*/}
                                        {/*        />*/}
                                        {/*    )}*/}
                                        {/*    {editMode && (*/}
                                        {/*        <Button*/}
                                        {/*            label={*/}
                                        {/*                chargeHeader.chhEvStatus === 2 ? "Update EV" : "Gen EV"*/}
                                        {/*            }*/}
                                        {/*            onClick={() => {*/}
                                        {/*                console.log("CHARGEHEADER ->> ", chargeHeader);*/}
                                        {/*                if (chargeHeader.chhEvStatus === 2) {*/}
                                        {/*                    handleOpenEvinvDrawer(2, chargeHeader.chhJobId, true);*/}
                                        {/*                } else {*/}
                                        {/*                    handleOpenEvinvDrawer(*/}
                                        {/*                        2,*/}
                                        {/*                        chargeHeader.chhJobId,*/}
                                        {/*                        false*/}
                                        {/*                    );*/}
                                        {/*                }*/}
                                        {/*            }}*/}
                                        {/*            disabled={*/}
                                        {/*                !genEvPermission ||*/}
                                        {/*                !(*/}
                                        {/*                    chargeHeader.chhEvStatus === 3 ||*/}
                                        {/*                    chargeHeader.chhEvStatus === 2*/}
                                        {/*                )*/}
                                        {/*            }*/}
                                        {/*        />*/}
                                        {/*    )}*/}
                                        {/*    {editMode && (*/}
                                        {/*        <Button*/}
                                        {/*            label={*/}
                                        {/*                chargeHeader.chhInvStatus === 2*/}
                                        {/*                    ? "Update INV"*/}
                                        {/*                    : "Gen INV"*/}
                                        {/*            }*/}
                                        {/*            onClick={() => {*/}
                                        {/*                if (chargeHeader.chhInvStatus === 2) {*/}
                                        {/*                    handleOpenEvinvDrawer(1, chargeHeader.chhJobId, true);*/}
                                        {/*                } else {*/}
                                        {/*                    handleOpenEvinvDrawer(*/}
                                        {/*                        1,*/}
                                        {/*                        chargeHeader.chhJobId,*/}
                                        {/*                        false*/}
                                        {/*                    );*/}
                                        {/*                }*/}
                                        {/*            }}*/}
                                        {/*            disabled={*/}
                                        {/*                !genInvPermission ||*/}
                                        {/*                !(*/}
                                        {/*                    chargeHeader.chhInvStatus === 3 ||*/}
                                        {/*                    chargeHeader.chhInvStatus === 2*/}
                                        {/*                )*/}
                                        {/*            }*/}
                                        {/*        />*/}
                                        {/*    )}*/}
                                        {/*</div>*/}
                                    </div>
                                </div>

                                <div className="ui divider"></div>

                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {!editMode ? (
                                        <Button
                                            type="submit"
                                            template="create"
                                            isLoading={isSubmitLoading}
                                            module={MODULES.Finance}
                                            // form={HEADER_FORM}
                                            // authenticated={true}
                                            editMode={editMode}
                                            onClick={(e) => {
                                                addCharge(e);
                                            }}

                                        />
                                    ) : (
                                        <Button
                                            type="submit"
                                            template="create"
                                            create={false}
                                            isLoading={isUpdateLoading}
                                            module={MODULES.Finance}
                                            // form={HEADER_FORM}
                                            // authenticated={true}
                                            editMode={editMode}
                                            onClick={(e) => {
                                                updateCharge(e);
                                            }}

                                        />
                                    )}
                                </div>
                            </>



                        )}
                </div>
            </div>
        </>
    )
}
export default AddTransporterCharges;